exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "main{height:100vh;width:100vw;overflow:scroll}#middle-screen{flex-grow:1}", ""]);

// exports
